require("./compare.scss");

import CompareService from "./compare-service";
import CompareComponentRenderer from "./compare-component-renderer";

(function ($, data) {
    const loadComponents = () => {
        $("#add_to_compare_buttons").children().each(function() {
            const elm = $(this);
            $(elm.data("target")).append(elm);
        });
    };

    $(function () {
        //  Render Compare Panel
        const domNode = document.body.appendChild(document.createElement("div"));
        new CompareComponentRenderer(domNode, data.comparePageUrl, data.translations).render();

        //  Render Add To Compare Buttons
        loadComponents();

        const toggleClickValue = (id, checked) => {
            const value = checked ? "compare-remove" : "compare-add";
            $(`.add-to-compare[data-id=${id}]`).attr("data-webm-clickvalue", value);
        };

        CompareService.getItems().forEach(x => {
            $(`.add-to-compare[data-id=${x.id}] input`).prop("checked", true);
            toggleClickValue(x.id, true);
        });

        $(document.body).on("compare:item-removed", function (e) {
            toggleClickValue(e.detail.id, false);
            $(`.add-to-compare[data-id=${e.detail.id}] input`).prop("checked", false);
        });

        $("body").on("click", ".add-to-compare input", function (e) {
	        e.stopPropagation();

            const elm = $(this);
            const parent = elm.parent();
            const eventDetail = {
                id: parent.data("id"),
                title: parent.data("title"),
                imageUrl: parent.data("imageUrl")
            };
            const eventName = elm.is(":checked") ? "compare:add-item" : "compare:remove-item";

            toggleClickValue(parent.data("id"), elm.is(":checked"));

            document.body.dispatchEvent(new CustomEvent(eventName, { detail: eventDetail }));
        });
    });

})(jQuery, window.compare_items_data);